/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { phasesControllerCreate } from '../fn/phases/phases-controller-create';
import { PhasesControllerCreate$Params } from '../fn/phases/phases-controller-create';
import { phasesControllerFindAll } from '../fn/phases/phases-controller-find-all';
import { PhasesControllerFindAll$Params } from '../fn/phases/phases-controller-find-all';
import { phasesControllerFindById } from '../fn/phases/phases-controller-find-by-id';
import { PhasesControllerFindById$Params } from '../fn/phases/phases-controller-find-by-id';
import { phasesControllerFindByPathwayId } from '../fn/phases/phases-controller-find-by-pathway-id';
import { PhasesControllerFindByPathwayId$Params } from '../fn/phases/phases-controller-find-by-pathway-id';
import { phasesControllerFindOne } from '../fn/phases/phases-controller-find-one';
import { PhasesControllerFindOne$Params } from '../fn/phases/phases-controller-find-one';
import { phasesControllerRemove } from '../fn/phases/phases-controller-remove';
import { PhasesControllerRemove$Params } from '../fn/phases/phases-controller-remove';
import { phasesControllerUpdate } from '../fn/phases/phases-controller-update';
import { PhasesControllerUpdate$Params } from '../fn/phases/phases-controller-update';
import { ResponsePhaseDto } from '../models/response-phase-dto';

@Injectable({ providedIn: 'root' })
export class PhasesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `phasesControllerFindAll()` */
  static readonly PhasesControllerFindAllPath = '/thalea-pathways/phases';

  /**
   * Get all phases with optional filtering.
   *
   * Retrieves phases based on the provided filter criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindAll$Response(params: PhasesControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePhaseDto>>> {
    return phasesControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all phases with optional filtering.
   *
   * Retrieves phases based on the provided filter criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindAll(params: PhasesControllerFindAll$Params, context?: HttpContext): Observable<Array<ResponsePhaseDto>> {
    return this.phasesControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePhaseDto>>): Array<ResponsePhaseDto> => r.body)
    );
  }

  /** Path part for operation `phasesControllerCreate()` */
  static readonly PhasesControllerCreatePath = '/thalea-pathways/phases';

  /**
   * Create a new phase.
   *
   * Creates a new phase record in the system.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phasesControllerCreate$Response(params: PhasesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
    return phasesControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new phase.
   *
   * Creates a new phase record in the system.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phasesControllerCreate(params: PhasesControllerCreate$Params, context?: HttpContext): Observable<ResponsePhaseDto> {
    return this.phasesControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePhaseDto>): ResponsePhaseDto => r.body)
    );
  }

  /** Path part for operation `phasesControllerFindByPathwayId()` */
  static readonly PhasesControllerFindByPathwayIdPath = '/thalea-pathways/phases/pathway/{tenant}/{pathwayId}';

  /**
   * Get phases by pathway ID.
   *
   * Retrieves all phases belonging to a specific pathway.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerFindByPathwayId()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindByPathwayId$Response(params: PhasesControllerFindByPathwayId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePhaseDto>>> {
    return phasesControllerFindByPathwayId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get phases by pathway ID.
   *
   * Retrieves all phases belonging to a specific pathway.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerFindByPathwayId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindByPathwayId(params: PhasesControllerFindByPathwayId$Params, context?: HttpContext): Observable<Array<ResponsePhaseDto>> {
    return this.phasesControllerFindByPathwayId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePhaseDto>>): Array<ResponsePhaseDto> => r.body)
    );
  }

  /** Path part for operation `phasesControllerFindOne()` */
  static readonly PhasesControllerFindOnePath = '/thalea-pathways/phases/{tenant}/{id}';

  /**
   * Get phase by tenant and ID.
   *
   * Retrieves a specific phase by its tenant and unique ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindOne$Response(params: PhasesControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
    return phasesControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get phase by tenant and ID.
   *
   * Retrieves a specific phase by its tenant and unique ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindOne(params: PhasesControllerFindOne$Params, context?: HttpContext): Observable<ResponsePhaseDto> {
    return this.phasesControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePhaseDto>): ResponsePhaseDto => r.body)
    );
  }

  /** Path part for operation `phasesControllerUpdate()` */
  static readonly PhasesControllerUpdatePath = '/thalea-pathways/phases/{tenant}/{id}';

  /**
   * Update a phase.
   *
   * Updates an existing phase record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phasesControllerUpdate$Response(params: PhasesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
    return phasesControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a phase.
   *
   * Updates an existing phase record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phasesControllerUpdate(params: PhasesControllerUpdate$Params, context?: HttpContext): Observable<ResponsePhaseDto> {
    return this.phasesControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePhaseDto>): ResponsePhaseDto => r.body)
    );
  }

  /** Path part for operation `phasesControllerRemove()` */
  static readonly PhasesControllerRemovePath = '/thalea-pathways/phases/{tenant}/{id}';

  /**
   * Delete a phase.
   *
   * Deletes an existing phase record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerRemove$Response(params: PhasesControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return phasesControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a phase.
   *
   * Deletes an existing phase record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerRemove(params: PhasesControllerRemove$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.phasesControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `phasesControllerFindById()` */
  static readonly PhasesControllerFindByIdPath = '/thalea-pathways/phases/id/{tenant}/{phaseId}';

  /**
   * Get phase by unique ID.
   *
   * Retrieves a specific phase by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phasesControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindById$Response(params: PhasesControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
    return phasesControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get phase by unique ID.
   *
   * Retrieves a specific phase by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phasesControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phasesControllerFindById(params: PhasesControllerFindById$Params, context?: HttpContext): Observable<ResponsePhaseDto> {
    return this.phasesControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePhaseDto>): ResponsePhaseDto => r.body)
    );
  }

}
